import Vue from 'vue'
import Router from 'vue-router'
import beforeEach from './guards/beforeEach'
import afterEach from './guards/afterEach'

Vue.use(Router)

let files = require.context('./', false, /^\.\/[^_].*\.js$/)
let filenames = files.keys()

function getRoutes (filename) {
  let file = files(filename)
  return file.default
    ? file.default
    : file
}

let routes = []
for (let filename of filenames) {
  let name = filename.replace(/^\.\//, '').replace(/\.js$/, '')
  if (name === 'index') continue

  let namePath = name.split(/\//)
  name = namePath.pop()
  routes.push(...getRoutes(filename))
}

const router = new Router({
  mode: 'hash',
  routes: [
    {
      path: '/',
      redirect: '/products'
    },
    ...routes
  ]
})

router.beforeEach(beforeEach)
router.afterEach(afterEach)

export default router



// WEBPACK FOOTER //
// ./client/router/index.js